<template>
    <div id="pt480" class="pt480" v-cloak>
        <breadcrumb :navListCustom="[{title:$t('common.labels.myPgage'), routerName: pt480Init.myPage, param: {pageNo: '81'}}, {title:$t('common.labels.pointInquiry'), routerName: '', param: {}}]"></breadcrumb>
        <div>
            <div class="itemTitle">
                <h2>{{$t('common.labels.myPgage')}}</h2>
            </div>
            <div class="section-inner">
                <!-- ポイント詳細 -->
                <div class="sectionTitle">
                    <h3>{{$t('common.labels.pointDetail')}}</h3>
                </div>
                <div class="pointDtl" v-if="getLengthObj(pt480Init.pointDetailList) > 0">
                    <table>
                        <thead>
                            <!-- ポイント数 -->
                            <th scope="col">{{$t('pt480.labels.pointNum')}}</th>
                            <!-- 有効期限 -->
                            <th scope="col">{{$t('pt480.labels.pointLimitDate')}}</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in pt480Init.pointDetailList" :key="index">
                                <!-- ポイント数 -->
                                <td scope="row" :aria-label="$t('pt480.labels.pointNum')">
                                    {{formatPrice(item.POINT_NUM)}}
                                </td>
                                <!-- 有効期限 -->
                                <td scope="row" :aria-label="$t('pt480.labels.pointLimitDate')">
                                    {{item.POINT_LIMIT_DATE}}
                                </td>    
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pointDtl" v-else>
                    <p>{{$t('pt480.labels.noPointDetailMsg')}}</p>
                </div>
                <!-- ポイント履歴 -->
                <div class="sectionTitle">
                    <h3>{{$t('common.labels.pointHistory')}}</h3>
                </div>
                <div class="pointHistory" v-if="getLengthObj(pt480Init.pointRirekiList) > 0">
                    <table>
                        <thead>
                            <!-- 日付 -->
                            <th scope="col">{{$t('pt480.labels.pointChgDate')}}</th>
                            <!-- 内容 -->
                            <th scope="col">{{$t('pt480.labels.naiyo')}}</th>
                            <!-- 変更ポイント数 -->
                            <th scope="col">{{$t('pt480.labels.pointChgNum')}}</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in pt480Init.pointRirekiList" :key="index">
                                <!-- 日付 -->
                                <td scope="row" :aria-label="$t('pt480.labels.pointChgDate')">
                                    {{item.POINT_CHG_DATE}}
                                </td>
                                <!-- 内容 -->
                                <td scope="row" :aria-label="$t('pt480.labels.naiyo')">
                                    {{item.NAIYO}}
                                </td>
                                <!-- 変更ポイント数 -->
                                <td scope="row" :aria-label="$t('pt480.labels.pointChgNum')">
                                    {{formatPrice(item.POINT_CHG_NUM)}}
                                </td>    
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pointHistory" v-else>
                    <p>{{$t('pt480.labels.noPointHistoryMsg')}}</p>
                </div>
                <!--戻るボタン-->
                <div v-if="pt480Init.backButtonFlg = 1">
                    <router-link :to="generateLinkParams(81, pt480Init.myPage)" class="submit-button-small">
                        {{$t('common.buttons.return')}}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /*
    * Name of component
    */
    name: "pt480",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        Breadcrumb
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isPagingDisplay: false,
            pt480ReqModel: {},
            pt480Init: {
                pointRirekiList: {},
                pointDetailList: {}
            },
            SiteConstants: SiteConstants,
            site: ""
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        
        if (_this.ptInitData){
            _this.pt480Init = _this.ptInitData;
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT480 + _this.$UrlConstants.DO_INIT, _this.pt480ReqModel).then(function(response) {
                _this.pt480Init = response.data;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        // 未ログインの場合、ログイン画面へ遷移
        if(_this.pt480Init.isLogin == false){
            const parameter = _this.generateLinkParams(18,_this.pt480Init.loginPage,{returnFlg: 1, fromMyPage: 1});
            _this.$router.push(parameter);
        }
    },
    /*
    * Methods
    */
    methods: {
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        /**
         * ポイント数の3桁毎のカンマ処理
         */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            const parameter = _this.generateLinkParams(81,_this.pt480Init.myPage);
            _this.$router.push(parameter);
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
    },
}
</script>